export default __webpack_public_path__ + "static/checkout-page-97483024cb048603b45e90f5b7f87088.png";